export function calculateRemainingDays(expiresAt: string): number {
    const now = new Date();
    const expireDate = new Date(expiresAt);
    const timeDiff = expireDate.getTime() - now.getTime();
    const daysDiff =  Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return daysDiff;
}